import { useRoutes } from 'react-router-dom';
import { routeTree } from './router';

export function App() {
  return useRoutes(routeTree);
}
